var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2084 0.833252H3.79175C3.02925 0.833252 2.29798 1.13615 1.75882 1.67532C1.21965 2.21449 0.916748 2.94575 0.916748 3.70825V13.2916C0.916748 14.0541 1.21965 14.7853 1.75882 15.3245C2.29798 15.8637 3.02925 16.1666 3.79175 16.1666H17.2084C17.9709 16.1666 18.7022 15.8637 19.2413 15.3245C19.7805 14.7853 20.0834 14.0541 20.0834 13.2916V3.70825C20.0834 2.94575 19.7805 2.21449 19.2413 1.67532C18.7022 1.13615 17.9709 0.833252 17.2084 0.833252V0.833252ZM3.79175 2.74992H17.2084C17.4626 2.74992 17.7063 2.85089 17.8861 3.03061C18.0658 3.21033 18.1667 3.45409 18.1667 3.70825L10.5001 8.38492L2.83341 3.70825C2.83341 3.45409 2.93438 3.21033 3.1141 3.03061C3.29383 2.85089 3.53758 2.74992 3.79175 2.74992V2.74992ZM18.1667 13.2916C18.1667 13.5457 18.0658 13.7895 17.8861 13.9692C17.7063 14.1489 17.4626 14.2499 17.2084 14.2499H3.79175C3.53758 14.2499 3.29383 14.1489 3.1141 13.9692C2.93438 13.7895 2.83341 13.5457 2.83341 13.2916V5.89325L10.0017 10.2728C10.1474 10.3569 10.3127 10.4012 10.4809 10.4012C10.6491 10.4012 10.8144 10.3569 10.9601 10.2728L18.1667 5.89325V13.2916Z",
    fill: "#9FA8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6c8a27f7ad09b56a2da137bf653748a4.svg";
export { ForwardRef as ReactComponent };